import {PERMISSION_STATE, USERID_STATE} from "~/states/state";

export  default function () {

    const  updateUserInfo = async (tokenValue : string) => {
        const token = useCookie('XSRF-TOKEN')
        const logged= useState('logged');
        const userid = useState(USERID_STATE)
        const permission = useState(PERMISSION_STATE)

        const data = await $fetch<any>('/api/user',{
            method: 'post',
            body: {token: tokenValue},
            baseURL: String(useNuxtApp().$apiUrl()),
        })

        logged.value = data?.status

        if (logged.value) {
            token.value = tokenValue
            userid.value = data?.data.id
            permission.value =  data?.data.permissions
        } else {
            throw 'User invalid!'
        }
    }

    const isUserLogged = async () => {

        const token = useCookie('XSRF-TOKEN')
        const logged= useState('logged');
        const userid = useState(USERID_STATE)
        const permission = useState(PERMISSION_STATE)

        if (logged.value)
            return  true

        const data = await $fetch<any>('/api/user',{
            method: 'post',
            body: {token: token.value},
            baseURL: String(useNuxtApp().$apiUrl()),
        })


        logged.value = data?.status

        if (logged.value) {
            userid.value = data?.data.id
            permission.value =  data?.data.permissions
        }

        return logged.value
    }

    return {
        isUserLogged,
        updateUserInfo
    }
}
